import type { ImMNElement } from '../../../common/elements/elementModelTypes';
import { getTaskListLabelIds } from '../../../common/taskLists/taskListLabelUtils';
import { isSingleEditorTaskList } from '../../../common/taskLists/taskListContentVersionUtils';
import type { TiptapContent } from '../../../common/tiptap/tiptapTypes';

/**
 * Determines the changes to be persisted for a task list element update.
 * - If the task list is a legacy task list then only the textContent is persisted
 * - If it's a new single-editor task list:
 *     - We also need to save the labels that are referenced by the task items in the textContent
 *     - This is so the element can be kept in sync with the labels within its content, and
 *     - All other element labels functionality will behave the same as it does for other elements
 */
export const getTaskListUpdateChanges = (
    element: ImMNElement,
    textContent: TiptapContent,
): { textContent: TiptapContent; labels?: string[] } =>
    isSingleEditorTaskList(element) ? { textContent, labels: getTaskListLabelIds(textContent) } : { textContent };
